
/**
 * CreateInspecaoPatrimonioItensUseCase
 */

import { ICreateInspecaoPatrimonioItensUseCase } from "../../../presentation/useCases/create/create_inspecao_patrimonio_itens_use_case";
import { IControlePatrimonioRepository } from "../../repositories/ControledePatrimonio";

export class CreateInspecaoPatrimonioItensUseCase implements ICreateInspecaoPatrimonioItensUseCase {
  constructor(private readonly repository: IControlePatrimonioRepository) { }

  async createInspecaoPatrimonioItens(
    idInspecaoPatrimonio: number | null,
    ordem: string | null,
    descricao: string | null,
    inspecao1: string | null,
    inspecao2: string | null,
    dataInspecao1: Date | null,
    dataInspecao2: Date | null,
    status: number | null,
  ): Promise<number> {
    return await this.repository.createInspecaoPatrimonioItens(
      idInspecaoPatrimonio,
      ordem,
      descricao,
      inspecao1,
      inspecao2,
      dataInspecao1,
      dataInspecao2,
      status,
    );
  }
}
